import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  success: false ,
  msg:'',
  result: [],
  exportresult: [],
  listresult:[],
  listsuccess:false,
  total_count: 0,
  page: 1,
  grpfilter:[],

});

export default function labelsReducer(state = initState, action) {
 // console.log('action',action);
  switch (action.type) {
  case actions.LABEL_LIST:
   return state.set('info', action.payload.info);
  case actions.LABEL_LIST_RESULT:
  return state
    .set('exportresult', action.result)
    .set('result', action.result)
    .set('success', action.success)
    .set('total_count', action.total_count)
    .set('grpfilter', action.grpfilter)
    .set('page', action.page);
  case actions.LABEL_FETCH_LIST_ID:
  return state
   .set('result', action.result)
   .set('success', action.success);
    default:
      return state;
  }
  //return state;
}
